import $ks from "./ks";

class DrawTimeToClock {
    constructor(clockElement) {
        this.clock = clockElement;
        this.hour, this.min, this.sec, this.ms;
    }

    init() {
        this.hour = $ks.ce({
            tag: 'span',
            class: 'hour',
            targetElement: this.clock
        });

        $ks.ce({
            tag: 'span',
            class: 'colon',
            targetElement: this.clock
        }).innerHTML = ':';

        this.min = $ks.ce({
            tag: 'span',
            class: 'min',
            targetElement: this.clock
        });

        $ks.ce({
            tag: 'span',
            class: 'colon',
            targetElement: this.clock
        }).innerHTML = ':';

        this.sec = $ks.ce({
            tag: 'span',
            class: 'sec',
            targetElement: this.clock
        });

        this.ms = $ks.ce({
            tag: 'span',
            class: 'ms',
            targetElement: this.clock
        });

        return this;
    }

    drawTime(time) {
        let ms, s, m, h;

        ms = (time % 100).toString();
        ms = ms.length === 1 ? `0${ms}`: ms;
        this.ms.textContent = ms;

        s = (Math.floor(time / 100) % 60).toString();
        s = s.length === 1 ? `0${s}`: s;
        this.sec.textContent = s;

        m = (Math.floor(time / (60 * 100)) % 60).toString();
        m = m.length === 1 ? `0${m}`: m;
        this.min.textContent = m;

        h = (Math.floor(time / (60 * 60 * 100))).toString();
        h = h.length === 1 ? `0${h}`: h;
        this.hour.textContent = h;
    }
}

export default DrawTimeToClock;
